import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatabaseService } from '../../../core/services/database.service';

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss']
})
export class ContactModalComponent {
  @Output() close = new EventEmitter<void>();

  form: FormGroup;
  submitted = false;
  success = false;

  constructor(private fb: FormBuilder, private databaseService: DatabaseService) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.submitted = true;
    this.databaseService.createLead(this.form.value).then(() => {
      this.success = true;
      this.form.reset();
      setTimeout(() => (this.success = false), 3000);
    }).finally(() => (this.submitted = false));
  }

  closeModal(): void {
    this.close.emit();
  }
}
